<template>
  <div class="form-lower entry thanks">
    <lang />
    <section class="wrapper">
      <div class="form_ttl">
        <h1>
          <router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}">
            <img src="@/assets/img/client/logo.png" alt="GLOCALY">
          </router-link>
        </h1>
      </div>
      <h2>{{ $t('member_registration_completed') }}</h2>
      <p class="center">{{ $t('thank_you_registering') }} <br>
      <span>{{ $t('completion_email') }}</span> <br>
      <span>{{ $t('member_site') }}</span></p>
       <p class="loginBtn"><router-link :to="{ name: 'Home', params: { lang: $route.params.lang }}" class="white_btn">{{ $t('to_the_login_screen') }}</router-link></p>
    </section>
  </div>
</template>

<script>
import lang from '@/components/client/language/language'
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

export default {
  data () {
    return {
      language: this.$route.params.lang
    }
  },
  created () {
    this.preventDirectLogin()
  },
  methods: {
    preventDirectLogin: function () {
      Vue.$cookies.remove('access_token_client')
    }
  },
  components: {
    lang
  }
}
</script>

<style lang="scss" src="@/assets/sass/client/index.scss">

</style>
